// Batch Sheet (owner) — the same calculator the manufacturer uses, so you can scale a recipe to a
// batch size and manage the standing batch notes per product. Notes save via /batch-notes (owner auth).
import { useData } from "../state/store.tsx";
import { api } from "../lib/api.ts";
import { skuRecipeKey } from "@shared/engine.ts";
import { BatchSheet } from "../components/BatchSheet.tsx";

export default function BatchSheetView() {
  const { data, reload, mutate } = useData();
  if (!data) return null;
  return (
    <BatchSheet
      skus={data.skus}
      recipes={data.recipes}
      conv={data.business.conversions}
      massUnit={data.business.massUnit}
      unitLabel={data.business.unitLabel}
      businessUnitVolumeL={data.business.unitVolumeL}
      onSaveNotes={async (skuId, notes) => { await api.batchNotes({ businessId: data.business.id, skuId, notes }); await reload(); }}
      onToggleLine={async (skuId, ingredient, hide) => {
        await mutate((draft) => {
          const s = draft.skus.find((x) => x.id === skuId);
          if (!s) return;
          const line = (draft.recipes[skuRecipeKey(s)] || []).find((l) => l.ingredient === ingredient);
          if (line) line.hideFromBatch = hide || undefined;
        });
      }}
    />
  );
}
